import styled, { css } from 'styled-components';
import tw from 'twin.macro';
import { Body } from '../../../../styled components/Typography';
import {
  changedTint,
  deletedText,
  setMemberRule,
  statusBackground
} from '../../ListViewBookings/ListViewBookings.style';
import type { BookingRowStatus } from '../../../types';

/* One member of a set inside a card, and the list its siblings are in. The
 * list is here rather than with the section that first renders it
 * (ListViewCardChildren), because a member that is a set itself renders the
 * same list again one level in — see NestedChildBookings. */

/* The members themselves, behind the rule that ties them to their set. The
   last one drops its separator, so the list ends on the card's edge rather
   than on a line. */
export const ChildBookingList = styled.div(() => [
  tw`mt-4 pl-12`,
  setMemberRule,
  css`
    & > div:last-child {
      ${tw`border-b-0`}
    }
  `
]);

export const ChildBooking = styled.div<{ $status: BookingRowStatus | undefined }>(
  ({ $status }) => [
    tw`py-4 px-8 border-0 border-b border-solid border-silver-lighten-20`,
    ...statusBackground($status, true),
    /* Unlike a card or a table row, a changed child is tinted as a whole: its
       fields are not column-addressed */
    $status === 'changed' && changedTint
  ]
);

/* The name of a member and the times it is booked for, on one line */
export const ChildBookingHeader = styled.div(tw`flex items-center`);

/* The member's name and its count, with the chevron in front when the member
   is a set itself. It takes the room the times on the right of the row leave,
   and never wraps: the name gives way within its own room, so the count stays
   on the name's line rather than dropping onto one of its own. */
export const ChildBookingLabel = styled.div(
  tw`flex flex-1 items-center flex-nowrap min-w-0`
);

export const ChildBookingName = styled(Body)<{ $deleted: boolean }>(({ $deleted }) => [
  tw`m-0 min-w-0`,
  $deleted && deletedText
]);

/* The members of a set that is itself a member of the card's set, nested one
   step further in. There is no depth limit, so this simply nests again for
   every level. */
export const NestedChildBookings = styled.div(tw`ml-16`);
